import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../api/client';
import SubTabs from './SubTabs';

type Settings = Record<string, unknown>;

const SettingsPage = () => {
  const queryClient = useQueryClient();
  const { data: settings } = useQuery({
    queryKey: ['settings'],
    queryFn: () => api.get<Settings>('/api/settings')
  });

  const [key, setKey] = useState('notification-preferences');
  const [value, setValue] = useState(JSON.stringify({ lowStock: true, roastComplete: true }, null, 2));
  const [activeTab, setActiveTab] = useState<'values' | 'update'>('values');

  const mutation = useMutation({
    mutationFn: (payload: { key: string; value: string }) =>
      api.put(`/api/settings/${payload.key}`, JSON.parse(payload.value)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings'] });
    }
  });

  const settingsEntries = Object.entries(settings ?? {});

  return (
    <div>
      <h2>Settings & Automation</h2>
      <p style={{ color: '#64748b' }}>
        Store JSON configuration for automations using Cloudflare KV. Use these settings to
        drive notification Workers or scheduled reports.
      </p>

      <SubTabs
        activeTab={activeTab}
        onChange={setActiveTab}
        tabs={[
          { id: 'values', label: 'Current KV Values', badge: settingsEntries.length },
          { id: 'update', label: 'Update Configuration' }
        ]}
      />

      {activeTab === 'update' ? (
      <div className="card" style={{ marginTop: 16 }}>
        <h3>Update configuration</h3>
        <div className="form-grid">
          <div className="form-group">
            <label>Key</label>
            <input value={key} onChange={(event) => setKey(event.target.value)} />
          </div>
          <div className="form-group" style={{ gridColumn: 'span 2' }}>
            <label>Value</label>
            <textarea rows={6} value={value} onChange={(event) => setValue(event.target.value)} />
          </div>
          <button
            className="btn primary"
            onClick={() => mutation.mutate({ key, value })}
            disabled={mutation.isPending}
          >
            {mutation.isPending ? 'Saving…' : 'Persist to KV'}
          </button>
        </div>
      </div>
      ) : null}

      {activeTab === 'values' ? (
      <section style={{ marginTop: 8 }}>
        <h3>Current KV values</h3>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Key</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {settingsEntries.map(([itemKey, itemValue]) => (
                <tr key={itemKey}>
                  <td>{itemKey}</td>
                  <td>
                    <pre style={{ margin: 0 }}>
                      {JSON.stringify(itemValue, null, 2)}
                    </pre>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      ) : null}
    </div>
  );
};

export default SettingsPage;
